module.exports = __webpack_public_path__ + "static/media/ta-03.405c8749.png";